import React from 'react';
import { injectIntl, intlShape } from "react-intl";
import Alert from "../../common/Alert";
import DocumentList from "../../common/DocumentList";
import Propertii from "../../common/Propertii";

class Documents extends Propertii {

    /**
     * Render the component.
     *
     * @returns {*} - The administrator companies dashboard component.
     */
    render() {

        return(
            <React.Fragment>

                <Alert validationList={this.state.validationList} validationType="primary" />

                <DocumentList token={this.props.token} parent={this} recordType="COMPANY" recordId={this.props.match.params.companyId} />

            </React.Fragment>
        )
    };
}

Documents.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Documents);